import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";

export default function useQrPhoneFill(apiAddr, applyQrEntries) {
  const [qrSession, setQrSession] = useState("");
  const [qrFilled, setQrFilled] = useState(0);
  const [qrDebug, setQrDebug] = useState([]);
  const qrPollRef = useRef(null);
  const qrWindowRef = useRef(null);
  const filledIdxRef = useRef(0);

  const addDebug = useCallback((msg) => {
    const time = new Date().toLocaleTimeString("ko-KR", { hour12: false });
    setQrDebug((prev) => [`[${time}] ${msg}`, ...prev].slice(0, 20));
  }, []);

  const stopQrPoll = useCallback(() => {
    if (qrPollRef.current) {
      clearInterval(qrPollRef.current);
      qrPollRef.current = null;
    }
    qrWindowRef.current = null;
  }, []);

  const startQrPoll = useCallback(
    (session) => {
      filledIdxRef.current = 0;
      addDebug(`폴링 시작 — session: ${session}`);

      qrPollRef.current = setInterval(async () => {
        if (qrWindowRef.current && qrWindowRef.current.closed) {
          stopQrPoll();
          addDebug("QR 창 종료");
          return;
        }
        try {
          const res = await axios.get(
            `${apiAddr}/get/qrpnum?session=${encodeURIComponent(session)}`,
          );
          const entries = Array.isArray(res.data) ? res.data : [];
          const newEntries = entries.slice(filledIdxRef.current);
          if (newEntries.length > 0) {
            applyQrEntries(newEntries);
            filledIdxRef.current = entries.length;
            setQrFilled(filledIdxRef.current);
            addDebug(`✅ ${newEntries.length}건 반영`);
          }
        } catch (e) {
          addDebug(`❌ ${e.message}`);
        }
      }, 2000);
    },
    [apiAddr, applyQrEntries, addDebug, stopQrPoll],
  );

  const openQrModal = useCallback(() => {
    const sid = `qr_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    setQrDebug([]);
    setQrFilled(0);
    setQrSession(sid);
    filledIdxRef.current = 0;
    const url = `/qr-display?session=${sid}&api=${encodeURIComponent(apiAddr)}`;
    const sw = 420;
    const sh = window.screen.availHeight;
    const sl = Math.max(0, window.screen.availWidth - sw);
    const win = window.open(
      url,
      "qr-display",
      `width=${sw},height=${sh},top=0,left=${sl},resizable=no,scrollbars=no`,
    );
    qrWindowRef.current = win;
    startQrPoll(sid);
  }, [apiAddr, startQrPoll]);

  useEffect(() => () => stopQrPoll(), [stopQrPoll]);

  useEffect(() => {
    const onMessage = (e) => {
      if (
        e.data &&
        e.data.type === "qr-display-close" &&
        (!e.data.session || e.data.session === qrSession)
      ) {
        stopQrPoll();
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [stopQrPoll, qrSession]);

  return {
    qrSession,
    qrFilled,
    qrDebug,
    openQrModal,
    stopQrPoll,
  };
}
